const CountryList = [
	// { name: "中国", value: "CN", currency: "CNY", currency_tag: "¥" },
	{ name: '英国', value: 'GB', currency: 'GBP', isAbnormal: false },
	{ name: '德国', value: 'DE', currency: 'EUR', isAbnormal: false },
	{ name: '法国', value: 'FR', currency: 'EUR', isAbnormal: false },
	{ name: '意大利', value: 'IT', currency: 'EUR', isAbnormal: false },
	{ name: '西班牙', value: 'ES', currency: 'EUR', isAbnormal: false },
	{ name: '荷兰', value: 'NL', currency: 'EUR', isAbnormal: false },
	{ name: '瑞典', value: 'SE', currency: 'SEK', isAbnormal: false },
	{ name: '波兰', value: 'PL', currency: 'PLN', isAbnormal: false },
	{ name: '沙特阿拉伯', value: 'SA', currency: 'SAR', isAbnormal: false },
	{ name: '美国', value: 'US', currency: 'USD', isAbnormal: false },
	{ name: '加拿大', value: 'CA', currency: 'CAD', isAbnormal: false },
	{ name: '墨西哥', value: 'MX', currency: 'MXN', isAbnormal: false },
	{ name: '日本', value: 'JP', currency: 'JPY', isAbnormal: false },
	{ name: '澳洲', value: 'AU', currency: 'AUD', isAbnormal: false },
	{ name: '阿联酋', value: 'AE', currency: 'AED', isAbnormal: false },
	{ name: '新加坡', value: 'SG', currency: 'SGD', isAbnormal: false },
	{ name: '印度', value: 'IN', currency: 'INR', isAbnormal: false },
	{ name: '巴西', value: 'BR', currency: 'BRL', isAbnormal: false },
]

const ProfitPercentage = {
	GB: 50,
	DE: 50,
	FR: 50,
	IT: 50,
	ES: 50,
	NL: 50,
	SE: 50,
	PL: 50,
	SA: 50,
	US: 50,
	CA: 50,
	MX: 50,
	JP: 50,
	AU: 50,
	AE: 50,
	SG: 50,
	IN: 50,
	BR: 50,
}

const SafetyFactor = {
	GB: '100',
	DE: '100',
	FR: '100',
	IT: '100',
	ES: '100',
	NL: '100',
	SE: '100',
	PL: '100',
	SA: '100',
	US: '100',
	CA: '100',
	MX: '100',
	JP: '100',
	AU: '100',
	AE: '100',
	SG: '100',
	IN: '100',
	BR: '100',
}

const TaxRate = {
	GB: 16.67,
	DE: 15.97,
	FR: 16.67,
	IT: 18.03,
	ES: 17.36,
	NL: 17.36,
	SE: 20.00,
	PL: 18.70,
	SA: 0,
	US: 0,
	CA: 0,
	MX: 0,
	JP: 0,
	AU: 0,
	AE: 0,
	SG: 0,
	IN: 0,
	BR: 0,
}

export { CountryList, ProfitPercentage, SafetyFactor, TaxRate }
